import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import formatAuthenticationProvider from '../../../services/formatters/authenticationProviderFormatter';
import CountriesDropdown from '../../portal/countriesDropdown';
import LanguagesDropdownContainer from '../../portal/languagesDropdown';
import PortalTextBox from '../../portal/portalTextBox';
import TextfieldFloatingText from '../../portal/textfieldFloatingText';
import styles from './style.scss';
import PortalToastrContainer from '../../portal/portalToastrContainer';

@inject('translationsStore', 'editUserProfileStore', 'authenticationProvidersStore')
@observer
class EditUserProfileForm extends Component {

    fieldsWidth = '330px';

    componentDidMount() {

        this.props.editUserProfileStore.getUserProfile().then((user) => {
            this.props.authenticationProvidersStore.getAllAuthenticationProviders().then((providers) => {

                const editUserProfileStore = this.props.editUserProfileStore;

                let provider = providers.filter(p => p.id == user.authenticationProviderId)[0];
                editUserProfileStore.setAuthenticationProviderFormatted(formatAuthenticationProvider(provider));
            });
        });
    }

    componentWillUnmount() {

        this.props.editUserProfileStore.resetEditProfileValues();
    }

    handleFirstNameChange = e => this.props.editUserProfileStore.setFirstName(e.target.value);
    handleFirstNameOnBlur = e => this.props.editUserProfileStore.validateFirstName();

    handleLastNameChange = e => this.props.editUserProfileStore.setLastName(e.target.value);
    handleLastNameOnBlur = e => this.props.editUserProfileStore.validateLastName();

    handleJobTitleChange = e => this.props.editUserProfileStore.setJobTitle(e.target.value);

    handleEmailChange = e => this.props.editUserProfileStore.setEmail(e.target.value);

    handleEmailOnBlur = e => this.props.editUserProfileStore.validateEmail(e.target.value);

    handlePhoneChange = e => this.props.editUserProfileStore.setPhone(e.target.value);

    handleCellPhoneNumberChange = e => this.props.editUserProfileStore.setCellPhoneNumber(e.target.value);

    handleCountryChange = (e, index, country) => this.props.editUserProfileStore.setCountry(country);

    handleOtherChange = e => this.props.editUserProfileStore.setOther(e.target.value);

    handleChangeLocaleId = (e, index, language) => {

        this.props.editUserProfileStore.setLocaleId(language);
    }

    render() {

        const { profileValues } = this.props.editUserProfileStore;

        return (
            <div>
                {
                    this.props.displaySuccessMessage ?
                        <span
                            className={classNames(styles.editProfileSucessMessage)}
                            data-cy={'profile-saved'}
                        >
                        </span> : null
                }
                <div className={classNames(styles.userProfileFormWrapper)}>
                    <div>
                        <PortalTextBox
                            hintText={this.props.translationsStore.translate('FIRST_NAME')}
                            floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('FIRST_NAME')}
                                required={true} />}
                            onChange={this.handleFirstNameChange}
                            onBlur={this.handleFirstNameOnBlur}
                            value={profileValues.firstName || ''}
                            errorText={this.props.editUserProfileStore.firstNameValidationMessage}
                            width={this.fieldsWidth}
                            dataCy={'profile-fname-field'}
                        />
                    </div>
                    <div>
                        <PortalTextBox
                            hintText={this.props.translationsStore.translate('LAST_NAME')}
                            floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('LAST_NAME')}
                                required={true} />}
                            onChange={this.handleLastNameChange}
                            onBlur={this.handleLastNameOnBlur}
                            value={profileValues.lastName || ''}
                            errorText={this.props.editUserProfileStore.lastNameValidationMessage}
                            width={this.fieldsWidth}
                            dataCy={'profile-lname-field'}
                        />
                    </div>
                    <div>
                        <PortalTextBox
                            hintText={this.props.translationsStore.translate('USER_NAME')}
                            floatingLabelText={this.props.translationsStore.translate('USER_NAME')}
                            disabled={true}
                            value={profileValues.userName || ''}
                            width={this.fieldsWidth}
                        />
                    </div>
                    <div>
                        <PortalTextBox
                            hintText={this.props.translationsStore.translate('EMAIL')}
                            floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('EMAIL')}
                                required={true} />}
                            onChange={this.handleEmailChange}
                            onBlur={this.handleEmailOnBlur}
                            value={profileValues.email || ''}
                            errorText={this.props.editUserProfileStore.emailValidationMessage}
                            width={this.fieldsWidth}
                            dataCy={'profile-email-field'}
                        />
                    </div>
                    <div>
                        <PortalTextBox
                            hintText={this.props.translationsStore.translate('JOB_TITLE')}
                            floatingLabelText={this.props.translationsStore.translate('JOB_TITLE')}
                            onChange={this.handleJobTitleChange}
                            value={profileValues.jobTitle || ''}
                            width={this.fieldsWidth}
                            dataCy={'profile-jobtitle-field'}
                        />
                    </div>
                    <div>
                        <PortalTextBox
                            hintText={this.props.translationsStore.translate('PHONE')}
                            floatingLabelText={this.props.translationsStore.translate('PHONE')}
                            onChange={this.handlePhoneChange}
                            value={profileValues.phoneNumber || ''}
                            width={this.fieldsWidth}
                            dataCy={'profile-phone-field'}
                        />
                    </div>
                    <div>
                        <PortalTextBox
                            hintText={this.props.translationsStore.translate('MOBILE_PHONE')}
                            floatingLabelText={this.props.translationsStore.translate('MOBILE_PHONE')}
                            onChange={this.handleCellPhoneNumberChange}
                            value={profileValues.cellPhoneNumber || ''}
                            width={this.fieldsWidth}
                            dataCy={'profile-cellphone-field'}
                        />
                    </div>
                    <div>
                        <CountriesDropdown
                            hintText={this.props.translationsStore.translate('COUNTRY')}
                            floatingLabelText={this.props.translationsStore.translate('COUNTRY')}
                            onChange={this.handleCountryChange}
                            value={profileValues.country || ''}
                            width={this.fieldsWidth}
                            translations={{
                                selectCountry: this.props.translationsStore.translate('SELECT_COUNTRY')
                            }}
                            dataCy={'profile-country-field'}
                        />
                    </div>
                    <div>
                        <PortalTextBox
                            hintText={this.props.translationsStore.translate('OTHER')}
                            floatingLabelText={this.props.translationsStore.translate('OTHER')}
                            onChange={this.handleOtherChange}
                            value={profileValues.other || ''}
                            width={this.fieldsWidth}
                            dataCy={'profile-other-field'}
                        />
                    </div>
                    <div>
                        <PortalTextBox
                            hintText={this.props.translationsStore.translate('TEAMS')}
                            floatingLabelText={this.props.translationsStore.translate('TEAMS')}
                            value={profileValues.teams || ''}
                            width={this.fieldsWidth}
                            disabled={true}
                        />
                    </div>
                    <div>
                        <LanguagesDropdownContainer
                            hintText={this.props.translationsStore.translate('LOCALE')}
                            floatingLabelText={this.props.translationsStore.translate('LOCALE')}
                            onChange={this.handleChangeLocaleId}
                            value={parseInt(profileValues.localeId)}
                            width={this.fieldsWidth}
                            dataCy={'profile-locale-field'}
                        />
                    </div>
                    <div>
                        <PortalTextBox
                            hintText={this.props.translationsStore.translate('AUTHENTICATION_PROVIDER')}
                            floatingLabelText={this.props.translationsStore.translate('AUTHENTICATION_PROVIDER')}
                            disabled={true}
                            value={this.props.editUserProfileStore.authenticationProviderFormatted || ''}
                            width={this.fieldsWidth}
                        />
                    </div>
                    <PortalToastrContainer />
                </div>
            </div>
        );
    }
}

export default EditUserProfileForm;
